var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5917_4734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.76956 9.44793L7.98255 11.6609L12.4085 7.23494M16.4657 9.44793C16.4657 13.5219 13.1631 16.8246 9.08905 16.8246C5.01504 16.8246 1.7124 13.5219 1.7124 9.44793C1.7124 5.37393 5.01504 2.07129 9.08905 2.07129C13.1631 2.07129 16.4657 5.37393 16.4657 9.44793Z",
    stroke: "#27A740",
    strokeWidth: 1.47533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5917_4734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7039,
    height: 17.7039,
    fill: "white",
    transform: "translate(0.237305 0.595703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.5774586b5565560f7af56510a856a010.svg";
export { ForwardRef as ReactComponent };